import {useAppContext} from "../../../../../contexts/AppContext";
import {useSearchParams} from "react-router-dom";
import {Controller, useForm} from "react-hook-form";
import {useEffect} from "react";
import {Card, Collapse, Grid, MenuItem, TextField} from "@mui/material";
import {TableFilterButtons} from "../../../../common/TableFilterButtons";

export function CategoryTableFilter({ isOpenFilters, isLoadingList, empresas }) {
    const { setEmpresaIdSession } = useAppContext();

    const [searchParams, setSearchParams] = useSearchParams()

    const nome = searchParams.get('nome');
    const id_empresa = searchParams.get('id_empresa');

    const perPage = searchParams.get('perPage');

    const { handleSubmit, reset, control } = useForm();


    useEffect(() => {
        reset({
            nome: nome ?? '',
            id_empresa: id_empresa ?? '',
        });
    }, [id_empresa, nome, reset])

    function handleSubmitFilter(data) {
        for (const key in data) {
            // remove campos vazios
            if (data[key] === '') {
                delete data[key];
            }
        }

        const queryFilters = {
            ...data,
            page: '1',
            perPage: perPage ?? '10'
        }

        // fill url params with filters
        setSearchParams(queryFilters);

        if (data.id_empresa) {
            setEmpresaIdSession(data.id_empresa);
        }
    }

    return (
        <Grid item xs={12} component="form" onSubmit={handleSubmit(handleSubmitFilter)}>
            <Collapse in={isOpenFilters}>
                <Card variant="outlined" sx={{ padding: 2 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <Controller
                                name="nome"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <TextField
                                        label="Nome da Categoria"
                                        fullWidth
                                        size="small"
                                        {...field}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <Controller
                                name="id_empresa"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <TextField
                                        select
                                        label="Empresa"
                                        fullWidth
                                        size="small"
                                        {...field}
                                    >
                                        {empresas.length > 0 && empresas.map((option) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.nomeFantasia}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}
                            />
                        </Grid>

                        <TableFilterButtons
                            isLoading={isLoadingList}
                            handleClearFilters={() => {
                                setSearchParams((state) => {
                                    state.delete('nome')
                                    // state.delete('id_empresa') // dont delete id_empresa, because it saved in session
                                    state.set('page', '1')

                                    return state
                                })

                                reset({
                                    nome: '',
                                    id_empresa: id_empresa ?? '',
                                });
                            }}
                        />
                    </Grid>
                </Card>
            </Collapse>
        </Grid>
    );
}